import React from "react";

export default function ArrowRightIcon(color) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.953 13.0478L16.1044 10.9413H1V9.05882H16.1044L13.953 6.90745L15.2528 5.60767L19.69 10L15.2528 14.3924L13.953 13.0478Z"
            />
        </svg>);
}